export default {
  tenant: (state) => state.tenant,
  tenantId: (state) => state.tenant.tenantId,
  mapConfig: (state) => state.tenant.config.map,
  weixinConfig: (state) => state.tenant.config.weixin,
  jurorId: (state) => state.userData.id,
  dictData: (state) => state.dictData
}



// WEBPACK FOOTER //
// ./src/store/getters.js